module.exports = __webpack_public_path__ + "static/media/toldos-y-persianas.a2ecf32c.jpg";